"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeTableVisualizer = void 0;
var tslib_1 = require("tslib");
var rectangle_1 = require("@devexpress/utils/lib/geometry/rectangle");
var base_visualizer_1 = require("./base-visualizer");
var ResizeTableVisualizer = (function (_super) {
    tslib_1.__extends(ResizeTableVisualizer, _super);
    function ResizeTableVisualizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResizeTableVisualizer.prototype.init = function (pageIndex, size) {
        this.pageIndex = pageIndex;
        this.bounds = new rectangle_1.Rectangle(0, 0, size.width, size.height);
    };
    ResizeTableVisualizer.prototype.show = function (newPosition) {
        this.bounds.x = newPosition.x;
        this.bounds.y = newPosition.y;
        this.raiseShow();
    };
    return ResizeTableVisualizer;
}(base_visualizer_1.BaseVisualizer));
exports.ResizeTableVisualizer = ResizeTableVisualizer;
